module.exports = __webpack_public_path__ + "static/media/siddharth-ananthapur-forest-trip-banner.9fa98915.jpg";